import { useAppointmentReminders } from '../hooks/useAppointmentReminders';
import { useLeadReminders } from '../hooks/useLeadReminders';
import { useNewLeadAlerts } from '../hooks/useNewLeadAlerts';
import { useSubscriptionDraftAlerts } from '../hooks/useSubscriptionDraftAlerts';

export const ReminderListener = () => {
  useAppointmentReminders();
  useLeadReminders();
  useNewLeadAlerts();
  useSubscriptionDraftAlerts();
  return null;
};

export default ReminderListener;













